module.exports = __webpack_public_path__ + "static/media/ic-instagram.072d9db2.svg";